import ImageBasic from "../Common/Image/ImageBasic";
import IMG from "../../constants/image";
import {text} from "../../constants/text";
import notificationStore from "../../store/notificationStore";
import {PATH} from "../../constants";
import {Link} from "react-router-dom";
import {NotificationItemHome} from "../Notification/NotificationItem";
import {isEmpty} from "lodash";

const NotiOrder = () => {
  const {notifications} = notificationStore();
  return (
    <div className="flex flex-col bg-white rounded-lg md:rounded-xl p-4 pb-[10rem] md:pb-0 space-y-4">
      <div className="flex items-center justify-between font-normal">
        <div className="text-sm">{text.notification}</div>
        <div className="flex items-center space-x cursor-pointer">
          <Link to={PATH.NOTIFICATION}>
            <div className="text-xs">{text.viewAll}</div>
          </Link>
          <ImageBasic className="w-3.5" src={IMG.icon.chevronRight}/>
        </div>
      </div>
      <div>
        {!isEmpty(notifications?.items) && notifications?.items?.slice(0, 3)?.map((notification) => (
          <NotificationItemHome
            key={notification.id}
            notification={notification}
          />
        ))}
      </div>
    </div>
  );
};
export default NotiOrder;
